import styled from "styled-components";

export const FooterContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding-inline: 20px;
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  border-top: 1px solid ${(props) => props.theme.colors.highClearGray};
  z-index: 10;

  color: ${(props) => props.theme.colors.davysGrey};

  & button:hover,
  & [role="button"]:hover {
    color: ${(props) => props.theme.colors.activeBlue};
  }
`; 